import moment from "moment";

export const PERIODS = {
  "2months": moment.duration(2, "months"),
  "6months": moment.duration(6, "months"),
  "1year": moment.duration(1, "year"),
  "2years": moment.duration(2, "years"),
  "4years": moment.duration(4, "years"),
};

export function getPeriodDateRange(key) {
  const duration = PERIODS[key];

  if (!duration) {
    throw new Error("Invalid period key: " + String(key));
  }

  const endDate = moment().endOf("day").toDate();
  const startDate = moment().subtract(duration).startOf("day").toDate();

  return { startDate, endDate };
}

export function getPeriodDeltaRange(engine, key) {
  if (engine?.periods?.has(key)) {
    return null;
  }

  const { startDate: absStart, endDate: absEnd } = getPeriodDateRange(key);

  let earliestCoveredStart = null;

  for (const coveredKey of engine?.periods?.keys() ?? []) {
    if (!PERIODS[coveredKey]) {
      continue;
    }
    const { startDate: coveredStart } = getPeriodDateRange(coveredKey);

    if (earliestCoveredStart === null || coveredStart < earliestCoveredStart) {
      earliestCoveredStart = coveredStart;
    }
  }

  if (!earliestCoveredStart) {
    return { start: absStart, end: absEnd };
  }

  const deltaEnd = moment(earliestCoveredStart).subtract(1, "ms").toDate();

  if (deltaEnd <= absStart) {
    return null;
  }

  return { start: absStart, end: deltaEnd };
}
